import {icons} from './../../assets/iconDef/icon.def'
export const nhmMenuDef = [
    {
        name: 'menu.nhm_reports',
        resource: 'nhm',
        icon: 'fa fa-user',
        url: 'nhm',
        auto_crud: true,
        breadcrumb: 'NHM Reports'
    }
]